import React, { lazy, Suspense } from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import { isPublicPath } from "@/lib/publicPaths";

// Split the bundle at the front door: public marketing visitors load only the
// lightweight PublicApp chunk; the heavy authenticated app loads on demand.
const App = lazy(() => import("@/App"));
const PublicApp = lazy(() => import("@/PublicApp"));

function Root() {
  const publicView = isPublicPath(window.location.pathname);
  return (
    <Suspense fallback={<div style={{ minHeight: "100vh", background: "#0f0f1a" }} />}>
      {publicView ? <PublicApp /> : <App />}
    </Suspense>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Root />
    </HelmetProvider>
  </React.StrictMode>,
);
